import { useState } from 'react';

export function useActiveSection() {
	const [activeSection, setActiveSection] = useState<'reddit' | 'facebook'>('reddit');
	const [lastUserIntent, setLastUserIntent] = useState<'reddit' | 'facebook' | null>(null);

	/**
	 * Handles the scroll event to determine which section is currently active.
	 * Compares distances of the first card of each section from the left side of the container.
	 */
	const handleSectionScroll = (scrollContainer: HTMLDivElement) => {
		// If there's an explicit user intent, such as navigating to the facebook section,
		// we don't want to change the active section.
		if (lastUserIntent !== null) return;

		const containerRect = scrollContainer.getBoundingClientRect();
		const containerLeft = containerRect.left;

		const firstRedditCard = scrollContainer.querySelector<HTMLElement>('[data-platform="reddit"]');
		const firstFacebookCard = scrollContainer.querySelector<HTMLElement>('[data-platform="facebook"]');
		if (!firstRedditCard || !firstFacebookCard) return;

		const redditRect = firstRedditCard.getBoundingClientRect();
		const facebookRect = firstFacebookCard.getBoundingClientRect();
		const redditDistance = Math.abs(redditRect.left + redditRect.width / 2 - containerLeft);
		const facebookDistance = Math.abs(facebookRect.left + facebookRect.width / 2 - containerLeft);
		const newActiveSection = redditDistance < facebookDistance ? 'reddit' : 'facebook';
		setActiveSection(newActiveSection);
	};

	/**
	 * Scrolls to a specific section (platform).
	 */
	const scrollToSection = (platform: 'reddit' | 'facebook', scrollContainer: HTMLDivElement) => {
		const targetCard = scrollContainer.querySelector<HTMLElement>(`[data-platform="${platform}"]`);
		if (!targetCard) return;
		setLastUserIntent(platform);
		setActiveSection(platform);

		const scrollLeft = targetCard.offsetLeft - scrollContainer.offsetLeft;
		scrollContainer.scrollTo({
			left: scrollLeft,
			behavior: 'smooth',
		});
	};

	const clearUserIntent = () => {
		setLastUserIntent(null);
	};

	return {
		activeSection,
		handleSectionScroll,
		scrollToSection,
		clearUserIntent,
	};
}
